import { Component } from '@angular/core';

@Component({
  selector: 'pc-circle-group-2',
  standalone: true,
  imports: [],
  templateUrl: './circle-group-2.component.html',
  styleUrl: './circle-group-2.component.scss'
})
export class CircleGroup2Component {

}
